import { render, staticRenderFns } from "./CadastrarEditarPerfilDialog.vue?vue&type=template&id=6758b8cc&scoped=true"
import script from "./CadastrarEditarPerfilDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarEditarPerfilDialog.vue?vue&type=script&lang=js"
import style0 from "./CadastrarEditarPerfilDialog.vue?vue&type=style&index=0&id=6758b8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6758b8cc",
  null
  
)

export default component.exports